Object.defineProperty(exports,"__esModule",{value:true});var ComplianceStatus=exports.ComplianceStatus={
COMPLIANT:'COMPLIANT',
NON_COMPLIANT:'NON_COMPLIANT',
NOTCOMPLIANT:'NOTCOMPLIANT'};


var PositionRuleStatus=exports.PositionRuleStatus={
OK:1,
VIOLATION:0};